import React from 'react';

import { getCampaignTypes } from '@/services/ws-orders/src/main/resources/rest-api';
import { useSubscribe } from '@/js/libs/observable';
import { useRequest } from '@/js/libs/use-request';

import { DEFAULT_DEBOUNCE_DELAY } from 'src/constants';
import type { Option } from 'src/types';

type UseCampaignTypesOptionsReturn = {
  options: Option<string>[];
  pending: boolean;
};

type UseCampaignTypesOptions = () => UseCampaignTypesOptionsReturn;

export const useCampaignTypesOptions: UseCampaignTypesOptions = () => {
  const getCampaignTypesRequest = useRequest({
    apiMethod: getCampaignTypes,
    params: {},
    debounce: DEFAULT_DEBOUNCE_DELAY,
  });

  const options = useSubscribe(
    getCampaignTypesRequest.data$,
    (response) =>
      response?.data.map((item) => ({
        label: item?.name ?? '',
        value: item.id,
      })) ?? [],
  );
  const pending = useSubscribe(getCampaignTypesRequest.pending$);

  return React.useMemo<UseCampaignTypesOptionsReturn>(
    () => ({
      options,
      pending,
    }),
    [options, pending],
  );
};
